/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("EditLayoutEngine", ["LeafLayoutEngine"], function (context, cls) {
  /**
   * @class EditLayoutEngine
   * @memberOf classes
   * @extends classes.LayoutEngineBase
   */
  cls.EditLayoutEngine = context.oo.Class(cls.LeafLayoutEngine, function ($super) {
    return /** @lends classes.EditLayoutEngine.prototype */ {
      __name: "EditLayoutEngine",

      /**
       * @inheritDoc
       */
      invalidateMeasure: function (invalidation) {
        // always invalidate for EDIT
        this._invalidateMeasure(invalidation);
        this._getLayoutInfo().invalidateMeasure();
      },

      /**
       * @inheritDoc
       */
      measureDecoration: function () {},

      /**
       * @inheritDoc
       */
      _measure: function () {
        const layoutInfo = this._widget.getLayoutInformation();
        const rawMeasure = layoutInfo.getRawMeasure();

        if (layoutInfo._widget.isVisible() && layoutInfo.needMeasure()) {
          layoutInfo.setMeasured(rawMeasure.getWidth(true), rawMeasure.getHeight(true));
        }
      }
    };
  });
});
